<template>
  <section class="hero-section">
    <div class="container">
      <div class="hero-section-top">
        <div class="hero-section-left">
          <h1>{{ page.title }}. Build your future now, not later</h1>
          <div class="buttons">
            <ApplyButton
              cta-section="hero"
              page-name="role-page"
              class="proxify-btn proxify-btn-white"
            />
            <Glassdoor />
          </div>
          <div class="data-information">
            <div>
              <CheckIcon color="green" />
              300+ new jobs every month
            </div>
            <div>
              <CheckIcon color="green" />
              Career coaching
            </div>
            <div>
              <CheckIcon color="green" />
              Top 2% talent network
            </div>
          </div>
        </div>
        <div class="hero-section-right">
          <NuxtPicture
            src="/images/role-page/hero-section/hero-dev.png"
            alt="hero"
          />
        </div>
      </div>
      <BenefitsSection />
    </div>
  </section>
</template>

<script>
import BenefitsSection from '~/components/Common/BenefitsSection/BenefitsSection.vue';
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';
import Glassdoor from '~/components/Common/Glassdoor/Glassdoor.vue';
import CheckIcon from '~/components/Common/Svg/CheckIcon.vue';

export default {
  components: { Glassdoor, CheckIcon, BenefitsSection, ApplyButton },
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import './HeroSection.scss';
</style>
